<template>
    <div class="edit-address">
        <div class="edit-address__container spacing-b-6">
            <TitleText class="spacing-b-6" level="2">
                {{ $ml.get('editAddressTitle') }}
            </TitleText>

            <Address
                ref="dof-shipping-address"
    
                :zip-code.sync="localShippingAddress.zipCode"
                :street.sync="localShippingAddress.street"
                :number.sync="localShippingAddress.number"
                :complement.sync="localShippingAddress.complement"
                :district.sync="localShippingAddress.district"
                :city.sync="localShippingAddress.city"
                :state.sync="localShippingAddress.state"
    
                :disable-street="disableStreet"
                :disable-district="disableDistrict"
                :disable-city="disableCity"
                :disable-state="disableState"
    
                :address-errors.sync="addressErrors"
    
                @postalCodeFetched="onZipCodeFetched"
            />
        </div>


        <div class="edit-address__cta-container">
            <ButtonsNextPreviousV2
                :disable-button-next="disableButtonSaveAndContinue"
                :loading="loading"
                :back-text="'cancel'"
                :next-text="'saveAndContinue'"
                @click-next="saveAndContinue"
                @click-previous="goToPreviousStep"
            />
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex';

    import { isNullOrWhitespace } from '@/helpers/stringHelper';

	import TitleText from '@/components/template/TitleText';
    import Address from '@/components/Address';
    import ButtonsNextPreviousV2 from '@/components/template/ButtonsNextPreviousV2';

	export default {
		components: {
			TitleText,
            Address,
            ButtonsNextPreviousV2,
		},

		data() {
			return {
				localShippingAddress: {},
                addressErrors: {},
                fetchedAddressFields: [],
                loading: false,
			};
		},

		created() {
            if(this.selectedShippingAddressId) {
                this.localShippingAddress = JSON.parse(JSON.stringify(this.selectedShippingAddress));
            } else{
                this.localShippingAddress = {
                    zipCode: '',
                    street: '',
                    complement: '',
                    number: '',
                    state: '',
                    city: '',
                    district: '',
                    country: 'BR',
                };
            }
        },

		mounted() {},

		computed: {
			...mapGetters({
                selectedShippingAddress: 'dataOnFile/getSelectedShippingAddress',
                selectedShippingAddressId: 'dataOnFile/getSelectedShippingAddressId',
			}),

            disableStreet: self => false,
            disableDistrict: self => false,
            disableCity: self => self.fetchedAddressFields.includes('city'),
            disableState: self => self.fetchedAddressFields.includes('state'),

            disableButtonSaveAndContinue() {
                return false;
            },
		},

		methods: {
            goToPreviousStep() {
                this.$store.dispatch('pipelineV2/pushTo', 'DataOnFileReview');
            },

            onZipCodeFetched(data) {
                this.fetchedAddressFields = [];
                if (!data) return;

                this.localShippingAddress.street = data.fields.Street;
                this.localShippingAddress.number = data.fields.Number || null;
                this.localShippingAddress.complement = data.fields.Complement || null;
                this.localShippingAddress.district = data.fields.District;
                this.localShippingAddress.city = data.fields.City;
                this.localShippingAddress.state = data.fields.State;

                if(isNullOrWhitespace(this.localShippingAddress.street) == false)
                    this.fetchedAddressFields.push('street');
                if(isNullOrWhitespace(this.localShippingAddress.district) == false)
                    this.fetchedAddressFields.push('district');
                if(isNullOrWhitespace(this.localShippingAddress.city) == false)
                    this.fetchedAddressFields.push('city');
                if(isNullOrWhitespace(this.localShippingAddress.state) == false)
                    this.fetchedAddressFields.push('state');
            },

            async saveAndContinue() {
                if(this.loading) return;
                this.loading = true;

                await this.$refs['dof-shipping-address'].validateAddress();

                if (this.addressErrors.items && this.addressErrors.items.length > 0) {
                    this.loading = false;
                    return;
                }

                try {
                    if (this.selectedShippingAddressId) {
                        await this.$store.dispatch('dataOnFile/editShippingAddress', this.localShippingAddress);
                    } else {
                        await this.$store.dispatch('dataOnFile/addShippingAddress', this.localShippingAddress);
                    }
                    this.$store.dispatch('pipelineV2/pushTo', 'DataOnFileReview');
                } catch (error) {
                    // TODO: tratar o erro na view?
                    console.error(error);
                } finally {
                    this.loading = false;
                }
            },
		},
	};
</script>

<style scoped lang="scss">
    .edit-address {
    }
</style>
